import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class RepresentativeShiftTemplateActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/ShiftTemplate/ShiftTemplateBrowser")
	}

	render() {
		return (
			<Activity 
				name="RepresentativeShiftTemplate"
				RenderedComponent={this.RenderedComponent}
				context="RepresentativeShiftTemplate"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(RepresentativeShiftTemplateActivity)
